
/**
 * Safely decodes a URI component, returning the original value if decoding fails.
 * @param value - The URI component to decode.
 * @returns The decoded URI component or the original value if decoding fails.
 */
export const safeDecode = (value: string) => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value; // fallback to raw value
  }
}